
import * as types from './types';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';

// Mutations Object for AccountsRoyalty. Use it by importing accounts/types.js and calling commit() from  accounts/actions.js Action File.
export const tasksMutations = {
  [types.TasksData.SET.ALL](state, payload) {
    state.tasksData = payload;
  },

  [types.TasksList.SET.ALL](state, payload) {
    console.log("payload mutt",payload)
    state.tasksList = payload;
    console.log("payload mutt after",state.tasksList)
  },

  [types.TasksList.UPDATE.SINGLE](state,payload){
    state.tasksList.licence_accounts=state.tasksList.licence_accounts.map(e => {
      if (e.licence_account_id == payload.kVal) {
        return {
          ...e,
          [payload.name]: payload.value
        };
      } else {
        return e;
      }
    })
  },

  [types.TasksList.DELETE.SINGLE](state, payload) {
    let list = state.tasksList?.licence_accounts;
    list = list.filter(e => e.licence_account_id !== payload.licence_account_id)
    state.tasksList = {
      ...state.tasksList,
      licence_accounts: [
        ...list
      ]
    }
  },
  ...implementSetAllNavTabDetailsMutation(types.TasksDetails, 'tasksDetails'),
}